import * as Tooltip from '@radix-ui/react-tooltip';
import { TooltipContent } from 'ui/tooltip/Tooltip.styled';
import { Caption } from 'ui/theme/typography';
import type { RangeSliderProps } from './types';
import { StyledRoot, StyledTrack, SliderRange, SliderThumb, Legend } from './RangeSlider.styled';

export const RangeSlider = ({
  hasTooltip = true,
  legendVisible = true,
  max = 100,
  min = 0,
  step,
  tooltipAlwaysVisible = true,
  value,
  ...props
}: RangeSliderProps) => {
  // we want the tooltip component to control its own visibility, if we're not forcing it to always be visible
  const open = tooltipAlwaysVisible ? true : undefined;

  return (
    <div>
      <StyledRoot max={max} min={min} step={step} value={value} {...props}>
        <StyledTrack>
          <SliderRange data-test="slider-track" />
        </StyledTrack>
        {Array.isArray(value) ? (
          value.map((val, i) => {
            return hasTooltip ? (
              <Tooltip.Provider key={i} delayDuration={0} skipDelayDuration={0}>
                <Tooltip.Root open={open}>
                  <Tooltip.Trigger asChild>
                    <SliderThumb data-test="slider-thumb" />
                  </Tooltip.Trigger>
                  <Tooltip.Portal>
                    <TooltipContent $animationDuration={400} sideOffset={4} data-test="tooltip">
                      {val}
                      <Tooltip.Arrow />
                    </TooltipContent>
                  </Tooltip.Portal>
                </Tooltip.Root>
              </Tooltip.Provider>
            ) : (
              <SliderThumb key={i} />
            );
          })
        ) : (
          <SliderThumb />
        )}
      </StyledRoot>
      {legendVisible && (
        <Legend aria-hidden="true" data-test="slider-range-legend">
          <Caption>{min}</Caption>
          <Caption>{max}</Caption>
        </Legend>
      )}
    </div>
  );
};
